import { Country } from 'src/api/zrm';

const languageFlags = {
  [Country.SE]: '/static/icons/se_flag.svg',
  [Country.NO]: '/static/icons/no_flag.svg',
};

export default languageFlags;
